import React from 'react';
import PropTypes from 'prop-types';
import { useLabels } from 'wsm-common-data';
import useStepClickHandler from '../hooks/useStepClickHandler';

const Step = ({
	isComplete,
	title,
	route,
	titleSideContent,
	showStepDivider = true,
	stepKey
}) => {
	const labels = useLabels();
	const onClickHandler = useStepClickHandler(route, title);

	const labelStatus = isComplete
		? labels.get('COMPLETE')
		: labels.get('INCOMPLETE');

	const btnLabel =
		stepKey === 'tradeIn'
			? `${labels
					.get('ADD_A_KBB_TRADE_IN_VALUE')
					.replace('{{breakline}}', ' ')}, ${labelStatus}`
			: `${title}, ${labelStatus}`;

	return (
		<>
			<button
				className="d-flex flex-column align-items-center btn-unstyled"
				style={{
					flexBasis: '16%'
				}}
				onClick={onClickHandler}
				type="button"
				aria-label={btnLabel}
			>
				<i
					className="ddc-icon-circle-check ddc-icon"
					style={{
						fontSize: '30px',
						color: isComplete
							? 'var(--color-info-500)'
							: 'var(--color-neutral-300)'
					}}
					aria-hidden="true"
				/>
				<span className="text-decoration-underline text-link text-link-muted ddc-font-size-xsmall">
					{title}
				</span>
				{titleSideContent && <div>{titleSideContent}</div>}
			</button>
			{showStepDivider && (
				<div
					className="d-flex align-self-center"
					style={{ padding: '20px 0' }}
				>
					<div className="border-right" style={{ height: '40px' }}>
						&nbsp;
					</div>
				</div>
			)}
		</>
	);
};

Step.propTypes = {
	isComplete: PropTypes.bool,
	title: PropTypes.string.isRequired,
	route: PropTypes.string.isRequired,
	titleSideContent: PropTypes.oneOfType([
		PropTypes.element,
		PropTypes.string
	]),
	showStepDivider: PropTypes.bool,
	stepKey: PropTypes.string
};

export default Step;
